module.exports = __webpack_public_path__ + "static/006553-e4d6acf437a2bbcd19f840722ebe00ba.jpg";